import { Tag } from "@bfc-software/pallet";
// eslint-disable-next-line no-restricted-imports -- follow-up: use useCurrentLocalization()
import { TFunction } from "i18next";
import { DetailField } from "./task-requirements";

import type { DestinationNode } from "./types";
import styles from "./shared.module.css";

export function DestinationNodeCard({
  node,
  t,
}: {
  node: DestinationNode | undefined;
  t: TFunction;
}) {
  // `destination_node` is optional on the wire: no node, no card.
  if (!node) return null;

  const { label, tone, idLabel, id } = describeNode(node, t);
  return (
    <div className={styles.loadLocationCard}>
      <Tag label={label} display={{ tone }} />
      <div className={styles.loadLocationFields}>
        <DetailField label={idLabel} value={id} />
      </div>
    </div>
  );
}

function describeNode(node: DestinationNode, t: TFunction) {
  switch (node.kind) {
    case "PALLET":
      return {
        label: t("page.taskDetail.destinationNode.pallet"),
        tone: "info" as const,
        idLabel: t("page.taskDetail.destinationNode.palletId"),
        id: node.pallet_id,
      };
    case "TRAILER_CONTAINER":
      return {
        label: t("page.taskDetail.destinationNode.trailerContainer"),
        tone: "warning" as const,
        idLabel: t("page.taskDetail.destinationNode.trailerContainerId"),
        id: node.trailer_container_id,
      };
    default: {
      // Exhaustiveness: a new `kind` after a regen fails typecheck here.
      const unreachable: never = node;
      return unreachable;
    }
  }
}
